import type { CSSProperties } from 'react';

type CSSPropertiesWithVars = CSSProperties & Record<`--${string}`, string>;

/** Exposes the addon icon paths as CSS custom properties, so the theme picks the right one. */
export function getAddonIconStyle(
  iconLightPath: string,
  iconDarkPath: string
): CSSPropertiesWithVars {
  return {
    '--icon-light-path': `url(${iconLightPath})`,
    '--icon-dark-path': `url(${iconDarkPath})`,
  };
}
